const PATH = "/api/v1/zobu";

const ENDPOINTS = {
  ZOBU_CHAT_SEED: "/chat/seed/",
  ZOBU_CHAT_THREAD: "/chat/thread/",
  ZOBU_CHAT_THREADS: "/chat/threads/",
  ZOBU_CHAT_THREADS_ARCHIVED: "/chat/threads/archived/",
  ZOBU_CHAT_MESSAGE: "/chat/message/",
};

export type ZobuEndpoints = keyof typeof ENDPOINTS;
export const ZobuCollection = { PATH, ENDPOINTS };
